import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAiPxjj-RccoezjQhoznhrTAjjHgKUXGu4",
    authDomain: "markets-shop-with-me.firebaseapp.com",
    projectId: "markets-shop-with-me",
    storageBucket: "markets-shop-with-me.firebasestorage.app",
    messagingSenderId: "818354229695",
    appId: "1:818354229695:web:c971f42f21bba19a1c510a"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);



export { db, auth };